<template>
  <main class="language-page safe-page">
    <AppNavBar backgroundColor="#fff" :title="t('mine.language')" />

    <section class="language-list">
      <button
        v-for="item in languages"
        :key="item.key"
        type="button"
        class="language-item"
        :class="{ active: currentLocale === item.key }"
        @click="selectLanguage(item.key)"
      >
        <span>{{ item.label }}</span>
        <app-image
          :src="currentLocale === item.key ? checkedIcon : uncheckedIcon"
          alt=""
          class="language-item__icon"
        />
      </button>
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useProfileStore } from '@/stores/profile';
import i18n from '@/i18n';
import { APP_LANGUAGE_OPTIONS, applyAppLocale, resolveLocale } from '@/utils/locale';
import checkedIcon from '@/assets/images/checkbox.png';
import uncheckedIcon from '@/assets/images/circleNo_gray_icon.png';

const { t } = useI18n();
const profileStore = useProfileStore();

const languages = computed(() => APP_LANGUAGE_OPTIONS);

const currentLocale = computed(() => resolveLocale(profileStore.locale || 'zh-CN'));

function selectLanguage(key) {
  const nextLocale = applyAppLocale(i18n, key);
  profileStore.setLocale(nextLocale);
}
</script>

<style scoped lang="scss">
.language-page {
  min-height: var(--app-viewport-height);
  padding: 0 14px 24px;
  background: #ffffff;
}

.language-list {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.language-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #c1c4cd;
  border-radius: 16px;
  background: #ffffff;
  color: #222222;
  font-size: 16px;
  line-height: 22px;
  text-align: left;

  &.active {
    border-color: #2667ff;
    background: #e2edff;
  }
}

.language-item__icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  object-fit: contain;
}
</style>
